import Papa from 'papaparse';

export const CSVToArray = csvString => Papa.parse(csvString);

export const transformCSVArray = (
    arrDataParam,
    options = {},
) => {
    const defaultOptions = {
        // find row with max not empty cells and remove all additional empty cells
        removeEmptyCellsAtEnd: false,
        removeEmptyRows: true,
        maxCellsInRow: -1,
        // string to fill empty rows
        fill: undefined,
        // remove rows with less than x cells, 0 -> do not remove rows
        minCellsInRow: 2,
    };

    const allOptions = {
        ...defaultOptions,
        ...options,
    };

    const {
        removeEmptyCellsAtEnd, removeEmptyRows, maxCellsInRow, fill, minCellsInRow,
    } = allOptions;

    let arrData = arrDataParam;
    if (removeEmptyCellsAtEnd) {
        arrData = arrData.map(row => {
            let lastNotEmptyIndex = -1;
            for (let i = 0; i < row.length; i += 1) {
                if (row[i]) {
                    lastNotEmptyIndex = i;
                }
            }
            return row.filter((cell, cellIndex) => {
                if (!cell && cellIndex > lastNotEmptyIndex) {
                    return false;
                }
                return true;
            });
        });
    }

    if (maxCellsInRow > -1) {
        arrData = arrData.map(row => row.filter((cell, cellIndex) => cellIndex < maxCellsInRow));
    }

    if (removeEmptyRows) {
        arrData = arrData.filter(row => row.length);
    }

    if (fill !== undefined) {
        arrData = arrData.map(row => {
            const missing = maxCellsInRow - row.length;
            for (let i = 0; i < missing; i += 1) {
                row.push(fill);
            }
            return row;
        });
    }

    if (minCellsInRow > 0) {
        arrData = arrData.filter(row => row.length >= minCellsInRow);
    }
    return (arrData);
};
